__turbopack_context__.v({
  "arrowContainer": "_5-nLwa_arrowContainer",
  "carousal": "_5-nLwa_carousal",
  "carousalItems": "_5-nLwa_carousalItems",
  "carousalParent": "_5-nLwa_carousalParent",
  "circleBlurBtn": "_5-nLwa_circleBlurBtn",
  "dMdNone": "_5-nLwa_dMdNone",
  "element": "_5-nLwa_element",
  "h3": "_5-nLwa_h3",
  "pr0": "_5-nLwa_pr0",
});
